import { LoginBonusKind } from '../../../../../services/exports/Constants';

export default {
  [LoginBonusKind.MobileAppSignupBonus]: {
    toast: 'Congrats! You’ve earned {{amount}} in cashback.',
  },
};
